<template>
  <div class="order-list">
    <div class="form-block">
      <el-form ref="form" :model="searchForm" label-width="80px" :inline="true">
        <el-form-item class="type-form-item" style="width: 90%" label="查询类型">
          <div class="search-type-btn">
            <div class="type-btn" v-for="btn in searchTypes" :class="{ 'active': searchType == btn.value }" @click="searchType = btn.value" :key="btn.value">{{ btn.label }}</div>
          </div>
        </el-form-item>
        <template v-if="searchType == 1">
          <el-form-item label="订单状态">
            <el-select v-model="searchForm.orderState" placeholder="请选择">
              <el-option v-for="item in orderStates" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单类型">
            <el-select v-model="searchForm.type" placeholder="请选择">
              <el-option v-for="item in orderTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建时间">
            <el-date-picker v-model="date" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="支付时间">
            <el-date-picker v-model="payDate" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="所属应用">
            <el-input v-model.trim="searchForm.appName" @keyup.native.enter="search" class="dim-search-input" placeholder="请输入应用名称"></el-input>
          </el-form-item>
          <el-form-item label="所属套餐">
            <el-input v-model.trim="searchForm.packageKey" @keyup.native.enter="search" class="dim-search-input" placeholder="请输入套餐名称/SKU"></el-input>
          </el-form-item>
          <el-form-item label="结算状态">
            <el-select v-model="searchForm.closeState" placeholder="请选择">
              <el-option v-for="item in closeStates" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </template>
        <el-form-item label v-show="searchType == 2">
          <el-input v-model.trim="searchForm.orderNo" class="search-input" prefix-icon="el-icon-search" @keyup.native.enter="search" placeholder="请输入详细的订单号"></el-input>
        </el-form-item>
        <el-form-item label>
          <el-button type="primary" @click="search">查询</el-button>
        </el-form-item>
      </el-form>
      <div class="down-block" @click="downloadList">
        <img src="../../assets/img/order-download.svg" alt />
        下载订单
      </div>
    </div>
    <div class="table-block">
      <new-table :data="tableData" :columns="columns" :pages="pages"></new-table>
    </div>
    <export-tip ref="exportTip" />
  </div>
</template>

<script>
import orderService from "../../apis/orderService";
import {
  OrderCloseState,
  OrderCloseStateLabel,
  OrderState,
  OrderStateLabel,
  OrderType,
  OrderTypeLabel
} from "../../service/enum";
import { dateFormat } from "../../utils/util";
import newTable from "../../components/new-table"

export default {
  name: "order-list",
  data() {
    const end = new Date();
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);

    return {
      pages: {
        props: {
          "page-size": 20,
          "current-page": 1,
          "total": 0,
          "page-sizes": [10, 20, 50, 100],
        },
        on: {
          "current-change": (p) => {
            this.handleCurrentChange(p)
          },
          "size-change": (p) => {
            this.sizesChange(p)
          }
        }
      },
      searchTypes: [
        { label: "模糊查询", value: 1 },
        { label: "精确查询", value: 2 },
      ],
      orderStates: [
        { label: OrderStateLabel[OrderState.all], value: OrderState.all },
        { label: OrderStateLabel[OrderState.wait], value: OrderState.wait },
        { label: OrderStateLabel[OrderState.success], value: OrderState.success },
        { label: OrderStateLabel[OrderState.cancel], value: OrderState.cancel },
        { label: OrderStateLabel[OrderState.refunding], value: OrderState.refunding },
        { label: OrderStateLabel[OrderState.refund], value: OrderState.refund },
        { label: OrderStateLabel[OrderState.rebate], value: OrderState.rebate },
      ],
      orderTypes: [
        { label: OrderTypeLabel[OrderType.all], value: OrderType.all },
        { label: OrderTypeLabel[OrderType.free], value: OrderType.free },
        { label: OrderTypeLabel[OrderType.trial], value: OrderType.trial },
        { label: OrderTypeLabel[OrderType.buy], value: OrderType.buy },
        { label: OrderTypeLabel[OrderType.renew], value: OrderType.renew },
        { label: OrderTypeLabel[OrderType.upgrade], value: OrderType.upgrade }
      ],
      closeStates: [
        { label: OrderCloseStateLabel[OrderCloseState.all], value: OrderCloseState.all },
        { label: OrderCloseStateLabel[OrderCloseState.unClose], value: OrderCloseState.unClose },
        { label: OrderCloseStateLabel[OrderCloseState.closed], value: OrderCloseState.closed },
      ],
      date: [dateFormat(start), dateFormat(end)],
      payDate: ["", ""],
      searchType: 1,//查询类型
      searchForm: {
        orderState: OrderState.all,//订单状态
        type: OrderType.all,//订单类型
        orderNo: "",//精准查找单号
        appName: "",//所属应用
        packageKey: "",//所属套餐
        closeState: OrderCloseState.all,//结算状态
      },
      tableData: [],
      columns: [
        { label: "订单号", prop: "orderNo", "min-width": "160px" },
        { label: "应用名称", prop: "appName", "min-width": "120px" },
        { label: "SKU", prop: "packageSku", "min-width": "100px" },
        { label: "套餐名称", prop: "packageName", "min-width": "120px" },
        {
          label: "购买时长", prop: "packagePeriodNum", "min-width": '90px',
          render: (h, scope) => {
            return (<div>
              <span>{scope.row.packagePeriodNum * scope.row.buyNum + (['', '天', '个月'][scope.row.packagePeriodUnit])}</span>
            </div>)
          },
        },
        {
          label: "付款金额", prop: "payMoney", "min-width": '90px',
          render: (h, scope) => {
            return (<div>
              <span>{orderService.toYuan(scope.row.payMoney)}</span>
            </div>)
          },
        },
        {
          label: "订单类型", prop: "maxUsers", "min-width": '90px',
          render: (h, scope) => {
            return (<div>
              <span>{OrderTypeLabel[scope.row.type] || ''}</span>
            </div>)
          },
        },
        {
          label: "用户姓名", prop: "maxUsers", "min-width": '90px',
          render: (h, scope) => {
            return (
              <div>
                <span>{(scope.row.buyUserInfo || {}).realName}</span>
              </div>
            )
          }
        },
        { label: "创建时间", prop: "creationTime", "min-width": '150px' },
        { label: "支付时间", prop: "payTime", "min-width": '150px' },
        {
          label: "订单状态", prop: "maxUsers", "min-width": '90px',
          render: (h, scope) => {
            return (
              <div>
                <span>{orderService.getOrderStateLabel(scope.row.orderState, scope.row.payState)}</span>
              </div>
            )
          }
        },
        {
          label: "有效期", prop: "endTime", "min-width": '180px',
          render: (h, scope) => {
            return (
              <div>
                <span>{scope.row.endTime ? `${dateFormat(scope.row.beginTime, 'yyyy/MM/dd')}- ${dateFormat(scope.row.endTime, 'yyyy/MM/dd')}` : ''}</span>
              </div>
            )
          }
        },
        {
          label: "结算状态", prop: "creationTime", "min-width": '90px',
          render: (h, scope) => {
            return (
              <div>
                <span>{OrderCloseStateLabel[scope.row.closeState]}</span>
              </div>
            )
          }
        },
        {
          label: "操作", "min-width": "100",
          render: (h, scope) => {
            return (
              <div>
                <el-button type="text" on={{
                  "click": () => {
                    this.orderInfo(scope.row, scope.$index)
                  }
                }}>详情
                </el-button>
              </div>
            )
          }
        }
      ]
    }
  },
  methods: {
    orderInfo(row) {
      this.$router.push({ path: '/order-list/order-details?orderNo=' + row.orderNo })
    },
    async getList() {
      this.postData.pageIndex = this.pages.props["current-page"];
      this.postData.pageSize = this.pages.props["page-size"];
      const res = await orderService.getOrderList(this.postData);
      this.pages.props.total = res.dataCount;
      this.tableData = res.data;
    },
    sizesChange(val) {
      this.pages.props["page-size"] = val;
      this.getList();
    },
    handleCurrentChange(pageIndex) {
      this.pages.props["current-page"] = pageIndex;
      this.getList();
    },
    search() {
      this.pages.props["current-page"] = 1;
      this.getList();
    },
    downloadList() {
      orderService.downloadList(this.postData);
      this.$refs.exportTip.open();
    },
  },

  computed: {
    postData() {
      const formState = this.searchForm.orderState;
      let orderState = "";
      let payState = "-1"; // 除待支付和支付成功外都是-1;
      switch (formState) {
        case OrderState.wait: // 待支付
          orderState = "1";
          payState = "0"
          break;
        case OrderState.success: // 支付成功
          orderState = "1";
          payState = "1"
          break;
        case OrderState.cancel: // 已取消
          orderState = "3";
          break;
        default: // 全部 (OrderState.all)、已退款(refund)、退款中(refunding)
          orderState = formState;
          break;
      }
      return this.searchType == 2 ? {
        orderNo: this.searchForm.orderNo,
      } : {
        ...this.searchForm,
        payState,
        orderState,
        orderNo: "",
        beginTime: this.date ? this.date[0] : "",
        endTime: this.date ? this.date[1] : "",
        payBeginTime: this.payDate ? this.payDate[0] : "",
        payEndTime: this.payDate ? this.payDate[1] : ""
      }
    }
  },
  mounted() {
    this.getList();
  },
  components: { newTable }
}
</script>

<style scoped lang="scss">
.order-list {
  display: flex;
  flex-direction: column;
  .form-block {
    position: relative;
    padding-bottom: 6px;
    .el-form--inline .el-form-item {
      margin-right: 30px;
      margin-bottom: 10px;
      .search-input {
        width: 320px;
      }
      .dim-search-input {
        width: 180px;
      }
      .el-button--small,
      .el-button--small.is-round {
        padding: 11px 41px;
      }
      .el-form-item__content {
        line-height: 36px;
      }
      .el-select {
        width: 180px;
      }
      .el-range-editor--small.el-input__inner {
        width: 240px;
      }
      .el-date-editor.el-date-editor--date {
        width: 154px;
      }
    }
    ::v-deep .el-form-item__label {
      padding-right: 0;
      text-align: left;
    }
    .type-form-item {
      ::v-deep .el-form-item__label {
        font-size: 16px;
      }
      .search-type-btn {
        line-height: 34px;
        font-size: 12px;
        display: flex;
        overflow: hidden;
        .type-btn {
          width: 113px;
          border: 1px solid #d1d1d1;
          text-align: center;
          color: #999;
          border-radius: 5px;
          position: relative;
          cursor: pointer;
          &:last-of-type {
            margin-left: -6px;
          }
          &.active {
            border-color: #1890ff;
            background-color: #1890ff;
            color: #fff;
            z-index: 1;
          }
        }
      }
    }
    .down-block {
      position: absolute;
      bottom: 18px;
      right: 13px;
      display: flex;
      font-size: 12px;
      color: #1890ff;
      cursor: pointer;
    }
  }
  .table-block {
    flex: 1;
    overflow: auto;
  }
  .page {
    padding-top: 6px;
    border-top: 1px solid #ebeef5;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
